import { Log, PlatformSettings } from '@lightningjs/sdk'
import { AppParams } from './app-params'
import { IAppInfo, IAapiInfo, IDebug, IFeatures } from './interfaces'
import { PLATFORM } from './enum'

export class Config implements IAppInfo, IAapiInfo, IFeatures, IDebug {
  //appInfo
  iptv = false
  siteId = '1'
  platform_id = ''
  currentAppVersion = ''
  buildVersion = '' //change the build version
  partner = ''

  //apiInfo
  apiVersionId = '6.0'
  apiVersion = 'sv6.0'
  apiEnv = ''
  fuseEnv = 'prod'
  env = ''
  nodeEnv = 'prod'
  appId = 9
  aContent = true
  logUrl = 'https://log.ifood.tv/'
  apiUrl = 'https://rapi.ifood.tv/'

  //App features
  enableCC = true
  enableCCSettings = false
  enableTvShows = true
  enableResumeVideo = true
  enableSuggestedChannels = false
  enableBanner = true
  enableDetailedActionLog = true
  enableSelectScreen = true
  enableQueueManagement = true
  useLocalStorage = false
  enableLiveRow = true
  enableTrickPlay = true
  enableGridAnimation = true
  enableSimpleAgeRatingDialog = false
  enableContextualBackspace = false  // for enabling one character removal at a time from search input while doing backspace 
  enableNetworkDisconnectionCheck = false 
  enableSocialMediaParentalControl = false
  enableAutoplayforAdult = false
  disableGeneralRow = true       //XFIN-1171
  enableOnlyURLDisplay = false
  enableDirectApiCall = true
  enableRetries: boolean = false
  enableGestureListener = false
  enableMidCarousel = true; // enable/disable mid carousel and non click row.
  enableAutoplay = true;
  enableTopCarousel = true;
  enableMidCarouselAutoplay = true;  // enable/disable autoplay for carousel rows


  //debug
  enableDebug = false
  consoleDebugLog = false
  testDeviceId = ''
  testCountry = ''
  testAdMode = false
  testAdTag = false
  testProviders = 0
  testAdFreewheel = false
  testAdTimeout = false
  testIndexError = false
  testSubCategoryError = false
  testVideoError = false
  testDisableToken = false
  testAutoplay = false
  testEnableNativePlayer = false

  appHostedPath = '' //root path for accessing the page.
  resouceUrl = '' //for accessing new/rresources
  apiPath = ''

  searchInput = ''
  defaultSearchInput = ''
  useHistory = false;
  playlistTitle = "Current video list";

  reloadOnError = true
  useDRMProxy = true
  useApiProxyForDrm = false

  //drm
  drmInfo = {
    widevineLisenceUrl: 'https://wv-keyos.licensekeyserver.com/',
    playreadyLisenceUrl: 'https://pr-keyos.licensekeyserver.com/core/rightsmanager.asmx'
  };

  banIcon = '<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm130.1 117.9c65.4 65.4 70 165.5 20.7 235.6L150.5 105.2c70.2-49.4 170.2-44.7 235.6 20.7zM125.9 386.1c-65.4-65.4-70-165.5-20.7-235.6L361.5 406.8c-70.2 49.4-170.2 44.7-235.6-20.7z"/></svg>';
  // ads related
  disableAds = false;
  adSdkToUse = 'ima'; // or ima / freewheel
  enableAdPodding	= false;
  useVmap = true;
  enableBugAds = true;
  enableMidrolls = true;
  fwCaids				= {
		914: 'filmrise_truecrime_00000',
		952: 'filmise_mysteries_00000',
		970: 'scifimovies_and_tvbyfawesome_00000',
		972: 'thrillermovies_and_tvbyfawesome_00000',
		236: 'fawesomeapp_00000'
	}
  isXBox = false;
  limitAdTracking = 0;
  ipAddress = '';
  deviceLmtVal = ''
  sessionId = ''

  testInfo = {
    testSamsungFuseAdTag: 'https://fuse.freeawesometv.com/safeads?lineitemid=156&FT_NO_OF_SLOTS=[FT_NO_OF_SLOTS]&FT_PREFETCH_REQUEST=[FT_PREFETCH_REQUEST]&FT_AD_SLOT_POSITION=[FT_AD_SLOT_POSITION]&FT_BUNDLE_ID=[FT_BUNDLE_ID]&FT_TIMESTAMP=[FT_TIMESTAMP]&FT_CONTEXT=[FT_CONTEXT]&FT_CONTENT_LENGTH=[FT_CONTENT_LENGTH]&FT_AD_BREAK_POSITION=[FT_AD_BREAK_POSITION]&FT_DEVICE_MAKE=[FT_DEVICE_MAKE]&FT_TRACKING_ENABLED=[FT_TRACKING_ENABLED]&FT_APP_VERSION=[FT_APP_VERSION]&FT_DEVICE_LANGUAGE=[FT_DEVICE_LANGUAGE]&FT_DEVICE_MODEL=[FT_DEVICE_MODEL]&FT_USER_AGENT=[FT_USER_AGENT]&FT_APP_NAME=[FT_APP_NAME]&FT_TRACKING_ID=[FT_TRACKING_ID]&FT_PRIMARY_GENRE=[FT_PRIMARY_GENRE]&FT_CONTENT_LANGUAGE=[FT_CONTENT_LANGUAGE]&FT_CONTENT_RATING=[FT_CONTENT_RATING]&FT_PUBLISHER=[FT_PUBLISHER]&FT_APP_STORE_URL=[FT_APP_STORE_URL]&FT_APP_STORE_ID=[FT_APP_STORE_ID]&FT_CONTENT_ID=[FT_CONTENT_ID]&FT_DEDUPE_ID=[FT_DEDUPE_ID]&FT_CONTENT_CATEGORY=[FT_CONTENT_CATEGORY]&FT_CONTENT_GENRE=[FT_CONTENT_GENRE]&FT_IFA_TYPE=Samsung&FT_SESSION_ID=[FT_SESSION_ID]',
    testAdUrl : 'https://ssp.lkqd.net/ad?pid=498&sid=951258&output=vast&execution=instream&placement=preroll&playinit=auto&volume=100&width=%5BPLAYER_WIDTH%5D&height=%5BPLAYER_HEIGHT%5D&dnt=FIRETV_ADS_TRACKING_ENABLED&gdpr=0&gdprcs=&ip=%5BIP_ADDRESS%5D&ua=FIRETV_ADS_USER_AGENT&appname=filmrise&bundleid=%5BBUNDLE_ID%5D&appstoreurl=%5BAPP_STORE_URL%5D&appversion=%5BAPP_VERSION%5D&aid=FIRETV_ADS_TRACKING_ID&contentlength=%5BCONTENT_LENGTH%5D&rnd=%5BCACHE_BUSTER%5D&contentid=%5BCONTENT_ID%5D&&contenttitle=%5BCONTENT_TITLE%5D',
    testYumeUrl : 'http://shadow01.yumenetworks.com/dynamic_preroll_playlist.vast2xml?domain=1552hCkaKYjg',
    testVizioTag : 'https://tv.springserve.com/rt/21642?w=1920&h=1080&cb=[FT_TIMESTAMP]&ip=[FT_IP_ADDRESS]&ua=[FT_USER_AGENT]&dnt=[FT_TRACKING_ENABLED]&dur=[FT_CONTENT_LENGTH]&device_language=[FT_DEVICE_LANGUAGE]&app_id=[FT_APP_STORE_ID]&app_bundle=[FT_BUNDLE_ID]&app_name=[FT_APP_NAME]&app_store_url=[FT_APP_STORE_URL]&video_id=[FT_CONTENT_ID]&rating=[FT_CONTENT_RATING]&content_genre=[FT_CONTENT_GENRE]&genre=[FT_PRIMARY_GENRE]&app_version=[FT_APP_VERSION]&publisher=[FT_PUBLISHER]&did=[FT_TRACKING_ID]&device_make=[FT_DEVICE_MAKE]&device_model=[FT_DEVICE_MODEL]&ifa_type=[FT_IFA_TYPE]&us_privacy=1YNN&coppa=0&unique_pod_id=[FT_DEDUPE_ID]&pod_type=[FT_CONTEXT]&bundle_id=[FT_BUNDLE_ID]&appname=[FT_APP_NAME]&appstoreurl=[FT_APP_STORE_URL]&adbucket_id=53&content_id=[FT_CONTENT_ID]&ft_rating=[FT_CONTENT_RATING]&iris_content_id=[FT_CONTENT_ID]&language=[FT_DEVICE_LANGUAGE]&break_pos=[FT_AD_BREAK_POSITION]&slot_pos=[FT_AD_SLOT_POSITION]&url=filmrise.com&ic=[FT_CONTENT_CATEGORY]&prodq=1&content_livestream=0&channel_name=[FT_APP_NAME]&inv_partner_domain=futuretodayinc.com&content_len=[FT_CONTENT_LENGTH]',
    testAdMode : false,
    testIMAAdPodding: false,
    testAdMp4 : false,
    testDeviceId : 'ABCDE12345',
    testCCMode : false,
    testCountry : '',
    testAdTimeout:false,
    testAdsIds:[],
    testAdFreewheel:false,
    testAdPath : 'https://testing2.freeawesometv.com/samsung/config/testad/',
    testAdProviders : [],
    testAdsIdsUrl: []
  }


  appUIConfig = {
    winW:window.innerWidth,
	  winH:window.innerHeight,
  };


  maxVideosFromApi = 10;
  apiDomain = 'rapi.ifood.tv';

  currentDeviceId='';

  skipHlsFromFreewheel = true;
  maxTotalAdDuration = 180;
  waterfallMinSeconds = 6;
  showAdLabelAs = 'timer';
  prefetchAds = true;
  prefetchTiming = 20;
  durationPerAd = 30;
  enableWaterfalling = true;
  adSkipCheckInterval = 20000;
  maxTotalAdCount		= 6; // total ads // this is not in use as it is duplicate of midrollAdMax
  enableAdCountCheck	= true;
  midrollAdMax = 6;
  enableIMAAdPodding = true;
  testIMAMacro = false;
  isAgePopupShown = false;
  enableFusePrefetch = false;
  fusePrefetchInterval = 50;
  enableSecurityToken = true;
  securityToken = "";
  disableCC = false;    // IPTV-2368  - For Samsung submission purspose CC is being disabled.
  disableTopCarouselFocus = false;  // For disabling top carousel focus on grid page if coming back from video-screen or MLP  



  constructor(qs: AppParams) {
    Log.info('Set Config', qs)
    if (!qs) return

    const partner = qs.partner
    // if (partner !== '') {
    //   if (partner == 'cox') {
    //     this.platform_id = PLATFORM.COX;
    //   } else if (partner == 'comcast') {
    //     this.platform_id = PLATFORM.COMCAST;
    //   } else if (partner == 'rogers') {
    //     this.platform_id = PLATFORM.ROGERS;
    //   } else if (partner == 'shaw') {
    //     this.platform_id = PLATFORM.SHAW;
    //   } else if (partner == 'platco' || partner == 'xglobal') {
    //     this.platform_id = PLATFORM.PLATCO;
    //   } else {
    //     this.platform_id = qs.platform_id;
    //   }
    //   this.partner = qs.partner
    // } else {
    //   this.platform_id = qs.platform_id;
    // }
    // if (this.platform_id == '') {
    //   this.platform_id = PLATFORM.COMCAST;
    // }
    if(this.enableFusePrefetch){
      this.prefetchTiming = 5;
    }
    this.platform_id = qs.platform_id;
    if (qs.siteId && qs.siteId !== '') {
      this.siteId = qs.siteId
    }

    if (qs.apiEnv && qs.apiEnv !== '') {
      this.apiEnv = qs.apiEnv
    }

    if (qs.fuseEnv && qs.fuseEnv !== '') {
      this.fuseEnv = qs.fuseEnv
    }    

    if (qs.nodeEnv && qs.nodeEnv !== '') {
      this.nodeEnv = qs.nodeEnv
    }

    if (qs.testCountry && qs.siteId !== '') {
      this.testCountry = qs.testCountry
    }

    if (qs.testIndexError && qs.testIndexError !== '') {
      if(qs.testIndexError == "true") {
        this.testIndexError = true
      }
    }

    if (qs.testSubCategoryError && qs.testSubCategoryError !== '') {
      if(qs.testSubCategoryError == "true") {
        this.testSubCategoryError = true
      }
    }

    if (qs.testVideoError && qs.testVideoError !== '') {
      if(qs.testVideoError == "true") {
        this.testVideoError = true
      }
    }

    if (qs.testAdMode && qs.testAdMode !== '') {
      this.testAdMode = qs.testAdMode
      if(this.testAdMode=="true"){
        this.testInfo.testAdMode = true
      }
    }

    if(qs.testIMAAdPodding && qs.testIMAAdPodding !== '') {
      if(qs.testIMAAdPodding == "true") {
        this.testInfo.testIMAAdPodding = true;
      }
    }

    if (qs.testAutoplay && qs.testAutoplay !== '') {
      if (qs.testAutoplay == "true") {
        this.testAutoplay = true;
      }
    }

    if(qs.testAdTag && qs.testAdTag !== '') {
      if(qs.testAdTag == "true") {
        this.testAdTag = true;
      }
    }

    

    // for ads testing
	if (this.testInfo.testAdMode && qs.testAdsProviders !== undefined && qs.testAdsProviders !== "") {
        this.setTestAdInfoUrl()
		const noOfProviders = parseInt(qs.testAdsProviders);
		const testProviders = [];
		for (var i = noOfProviders - 1; i >= 0; i--) {
			testProviders.push({
				name: "ima",
				adTimeLimitDurartion: 0,
				provider: "ad-provider-" + i,
				priority: i,
				type: "video",
				rowId: i,
				url: this.testInfo.testAdsIdsUrl[0]
			});
		}
		this.testInfo.testAdProviders = testProviders;
	}

	//for testing the ad pods with the different ad url for testing the ad errors.
	if (this.testInfo.testAdMode && qs.testAdsIds !== "") {
		this.testInfo.testAdsIds = [];
		var ids = qs.testAdsIds.split(',');
		this.adSdkToUse = 'ima'
		this.testInfo.testAdsIds = ids;

	}

    if (qs.testAdFreewheel && qs.testAdFreewheel !== '') {
      this.testAdFreewheel = qs.testAdFreewheel
      if(this.testAdFreewheel=="true"){
        this.testInfo.testAdFreewheel = true
      }
    }



    if (qs.testAdTimeout && qs.testAdTimeout !== '') {
      this.testAdTimeout = qs.testAdTimeout
    }

    var debugConsole = qs.debugConsole;
    if (debugConsole == "true" || debugConsole == true) {
      this.enableDebug = true
      this.consoleDebugLog = true
    }

    if (qs.testDeviceId && qs.testDeviceId !== '') {
      this.testDeviceId = qs.testDeviceId
    }

    var testDisableToken = qs.testDisableToken;
    if (testDisableToken == "true" || testDisableToken == true) {
      this.testDisableToken = true      
    }

    var testEnableNativePlayer = qs.testEnableNativePlayer;
    if (testEnableNativePlayer == "true" || testEnableNativePlayer == true) {
      this.testEnableNativePlayer = true      
    }

    var testIMAMacro = qs.testIMAMacro;
    if (testIMAMacro == "true" || testIMAMacro == true) {
      this.testIMAMacro = true
    }

    var disableAds = qs.disableAds;
    if (disableAds == "true" || disableAds == true) {
      this.disableAds = true;
    }

    var enableMidrolls = qs.enableMidrolls;
    if (enableMidrolls == "false" || enableMidrolls == false) {
      this.enableMidrolls = false;
    }

    var reloadOnError = qs.reloadOnError;
    if (reloadOnError == "false" || reloadOnError == false) {
      this.reloadOnError = false;
    }

    var enableGridAnimation = qs.enableGridAnim;
    if (enableGridAnimation == "false" || enableGridAnimation == false) {
      this.enableGridAnimation = true;
    }

    this.appEnv = ''
    if (qs.appEnv && qs.appEnv !== '') {
      this.appEnv = qs.appEnv
    }

    this.searchInput = this.defaultSearchInput

    //setup testAdInfo data

  }

  setTestAdInfoUrl() {
    this.testInfo.testAdsIdsUrl = [
      this.testInfo.testAdPath + 'spotx-test-ad.xml?FT_TRACKING_ID=[FT_TRACKING_ID]&FT_TRACKING_ENABLED=[FT_TRACKING_ENABLED]&FT_IFA_TYPE=[FT_IFA_TYPE]&FT_PLAYER_HEIGHT=[FT_PLAYER_HEIGHT]&FT_PLAYER_WIDTH=[FT_PLAYER_WIDTH]&FT_IP_ADDRESS=[FT_IP_ADDRESS]&FT_APP_NAME=[FT_APP_NAME]&FT_BUNDLE_ID=[FT_BUNDLE_ID]&FT_APP_STORE_ID=[FT_APP_STORE_ID]&FT_TIMESTAMP=[FT_TIMESTAMP]&FT_CONTENT_ID=[FT_CONTENT_ID]&FT_CONTENT_TITLE=[FT_CONTENT_TITLE]&FT_CONTENT_SERIES=[FT_CONTENT_SERIES]&FT_CONTENT_LENGTH=[FT_CONTENT_LENGTH]&FT_CONTENT_RATING=[FT_CONTENT_RATING]&FT_CONTENT_GENRE=[FT_CONTENT_GENRE]&FT_PRIMARY_GENRE=[FT_PRIMARY_GENRE]&FT_DEVICE_OS=[FT_DEVICE_OS]&FT_DEVICE_OS_VER=[FT_DEVICE_OS_VER]&FT_DEVICE_MAKE=[FT_DEVICE_MAKE]&FT_DEVICE_MODEL=[FT_DEVICE_MODEL]&FT_APP_VERSION=[FT_APP_VERSION]&FT_APP_STORE_URL=[FT_APP_STORE_URL]&FT_VIDEO_ID=[FT_VIDEO_ID]&FT_PUBLISHER=[FT_PUBLISHER]&FT_PUBLISHER_ID=[FT_PUBLISHER_ID]&FT_CONTEXT=[FT_CONTEXT]&FT_AD_BREAK_POSITION=[FT_AD_BREAK_POSITION]&FT_AD_SLOT_POSITION=[FT_AD_SLOT_POSITION]&FT_L1_AG=[FT_L1_AG]&FT_PLAYLIST=[FT_PLAYLIST]&FT_SESSION_ID=[FT_SESSION_ID]&FT_SITE_ID=[FT_SITE_ID]&FT_CONTENT_CATEGORY=[FT_CONTENT_CATEGORY]&FT_CONTENT_SEASON=[FT_CONTENT_SEASON]&FT_CONTENT_EPISODE=[FT_CONTENT_EPISODE]&FT_CONTENT_PRODUCER=[FT_CONTENT_PRODUCER]&FT_DEVICE_LANGUAGE=[FT_DEVICE_LANGUAGE]&FT_DOMAIN=[FT_DOMAIN]&FT_DEVICE_CONNECTION_TYPE=[FT_DEVICE_CONNECTION_TYPE]&FT_DEVICE_LOCATION_GEO=[FT_DEVICE_LOCATION_GEO]&FT_DEVICE_LOCATION_LAT=[FT_DEVICE_LOCATION_LAT]&FT_DEVICE_LOCATION_LONG=[FT_DEVICE_LOCATION_LONG]&FT_US_PRIVACY=[FT_US_PRIVACY]&FT_DEDUPE_ID=[FT_DEDUPE_ID]&FT_BUILD=[FT_BUILD]&FT_CONTENT_AG=[FT_CONTENT_AG]&FT_CONTENT_GENDER=[FT_CONTENT_GENDER]&FT_CONTENT_BRAND=[FT_CONTENT_BRAND]&FT_MASKED_IP=[FT_MASKED_IP]&FT_SYNTHETIC_AD_ID=[FT_SYNTHETIC_AD_ID]&FT_POD_DURATION=[FT_POD_DURATION]&FT_CONTENT_LANGUAGE=[FT_CONTENT_LANGUAGE]&FT_NO_OF_SLOTS=[FT_NO_OF_SLOTS]&FT_COPPA=[FT_COPPA]&FT_USER_AGENT=[FT_USER_AGENT]&APP_NAME=[APP_NAME]&APP_STORE_URL=[APP_STORE_URL]&CACHEBUSTER=[CACHEBUSTER]&CONTENT_CHANNEL=[CONTENT_CHANNEL]&CONTENT_EPISODE=[CONTENT_EPISODE]&CONTENT_GENRE=[CONTENT_GENRE]&CONTENT_ID=[CONTENT_ID]&CONTENT_LANGUAGE=[CONTENT_LANGUAGE]&CONTENT_NETWORK=[CONTENT_NETWORK]&CONTENT_PRODUCER_NAME=[CONTENT_PRODUCER_NAME]&CONTENT_RATING=[CONTENT_RATING]&CONTENT_SERIES=[CONTENT_SERIES]&CONTENT_TITLE=[CONTENT_TITLE]&COPPA=[COPPA]&CUSTOM_5=[CUSTOM_5]&DEVICE_LANGUAGE=[DEVICE_LANGUAGE]&DEVICE_TYPE=[DEVICE_TYPE]&DID=[DID]&DNT=[DNT]&IFA_TYPE=[IFA_TYPE]&IP=[IP]&IRIS_ID=[IRIS_ID]&LIMITED_AD_TRACKING=[LIMITED_AD_TRACKING]&LIVESTREAM=[LIVESTREAM]&TIMESTAMP=[TIMESTAMP]&UA=[UA]&US_PRIVACY=[US_PRIVACY]&FT_CONTENT_CHANNEL=[FT_CONTENT_CHANNEL]&FT_BUNDLE_ID=[FT_BUNDLE_ID]&FT_CONTENT_NETWORK=[FT_CONTENT_NETWORK]',
      this.testInfo.testAdPath + 'ad_empty.xml?', //Video playlist unfilled vast request.
      this.testInfo.testAdPath + 'spotx-test-ad-404.xml?', //Video playlist 404 error.
      this.testInfo.testAdPath + 'ad_mp4_corrupted.xml?', //Video playlist 200 response with corrupted or invalid creative.
      this.testInfo.testAdPath + 'samsung-400-tag009.xml?', //samsung tag 9 checking 400 creative playback error
      this.testInfo.testAdPath + 'ad-poded-all-filled.xml?',
      this.testInfo.testAdPath + 'ad-poded-all-filled-corrupted.xml?',
      this.testInfo.testAdPath + 'ad-poded-all-filled-400.xml?noOfSlot=[FT_NO_OF_SLOTS]',
      this.testInfo.testAdPath + 'samsung-tag001.xml?', //samsung tag 1
      this.testInfo.testAdPath + 'samsung-tag002.xml?', // samsung tag 2
      this.testInfo.testAdPath + 'ad_jaguar_1.xml?', // jaguar ad which skipped on playing
      this.testInfo.testAdPath + 'ad_jaguar_2.xml?', // jaguar ad which skipped on playing
      this.testInfo.testAdPath + 'ad_jaguar_2_lovesac_highbitrate.xml?', // sortAd with high bitrate 19000kbs.
      this.testInfo.testAdPath + 'ad_wahabear.xml?', //hanged after the ad in vizio.
      this.testInfo.testAdPath + 'ad_media_no_cors.xml?', //cors error in creative.
      this.testInfo.testAdPath + 'ad_video_timeout.xml?', //video timeout.
      //media types testing
      this.testInfo.testAdPath + 'ad_webm_vizio.xml?', // webm video with no audio in vizio.
      this.testInfo.testAdPath + 'ad_ogg_vizio.xml?',// not supported
      this.testInfo.testAdPath + 'ad_3gp_vizio.xml?', // not supported.
      this.testInfo.testAdPath + 'ad_multiple_creative_types.xml?', // multiple creatives.
      this.testInfo.testAdPath + 'ad_multiple_creative_higherbit_mp4.xml?', // multiple creatives.
      this.testInfo.testAdPath + 'ad_multiple_creative_real_ad_selects_webm.xml?', //real ad creative selects the WebAssembly.
      'https://pbs.getpublica.com/v1/s2s-hb?site_id=5600&cb=[FT_TIMESTAMP]&ip=[FT_IP_ADDRESS]&ua=[FT_USER_AGENT]&app_bundle=samsung.scn.158&format=vast&slot_count=1&max_ad_duration=30&h=1080&w=1920&app_name=Samsung%20Content%20Network&did=[FT_TRACKING_ID]&is_lat=[FT_TRACKING_ENABLED]&content_genre=GV&content_cat=IAB1-5,IAB1-7&livestream=0&us_privacy=[FT_US_PRIVACY]', //Samsung Fawesome tag telatia pri:1
      'https://pd13201-k3qg1.ads.tremorhub.com/ad/mtag?adCode=PD13201-lzoxs&playerWidth=[FT_PLAYER_WIDTH]&playerHeight=[FT_PLAYER_HEIGHT]&videoId=[FT_CONTENT_ID]&deviceOS=[FT_DEVICE_OS]&deviceModel=[FT_DEVICE_MODEL]&deviceMake=LG&deviceId=[FT_TRACKING_ID]&deviceDNT=[FT_TRACKING_ENABLED]&deviceUA=[FT_USER_AGENT]&appBundle=lg.ifoodtv&videoTitle=[FT_CONTENT_TITLE]&series=[FT_CONTENT_SERIES]&contentLength=[FT_CONTENT_LENGTH]&appName=ifood.tv&genre=[FT_CONTENT_GENRE]&us_privacy=1YNN', // LG ifood tag
      'https://PD13201-odsv3.ads.tremorhub.com/ad/mtag?adCode=PD13201-tcplq&playerWidth=[FT_PLAYER_WIDTH]&playerHeight=[FT_PLAYER_HEIGHT]&videoId=[FT_CONTENT_ID]&deviceOS=[FT_DEVICE_OS]&deviceModel=[FT_DEVICE_MODEL]&deviceId=[FT_TRACKING_ID]&deviceDNT=[FT_TRACKING_ENABLED]&deviceUA=[FT_USER_AGENT]&appBundle=vizio.fawesome&videoTitle=[FT_CONTENT_TITLE]&series=[FT_CONTENT_SERIES]&contentLength=[FT_CONTENT_LENGTH]&appName=[FT_APP_NAME]&genre=[FT_CONTENT_GENRE]&us_privacy=1YNN&ifaType=[FT_IFA_TYPE]', //vizio 236 tag
      this.testInfo.testAdPath + 'samsung-tag003-blank_ad.xml?', //real ad creative selects the WebAssembly.
      this.testInfo.testAdPath + 'samsung-tag004.xml?', //real ad creative selects the WebAssembly.
      this.testInfo.testAdPath + 'samsung-tag005.xml?', //real ad creative selects the WebAssembly.
      this.testInfo.testAdPath + 'samsung-vpaid-app-hang.xml?', //samsung vpaid ad not playing
      this.testInfo.testAdPath + 'samsung-invalid400-inline-tag006.xml?', //samsung vpaid ad not playing
      this.testInfo.testAdPath + 'samsung-invalid400-wrapper-tag006.xml?', //samsung vpaid ad not playing
      this.testInfo.testAdPath + 'samsung-invalid400-wrapper-tag006.xml?', //samsung vpaid ad not playing
	  ];
    if(this.testInfo.testIMAAdPodding) {
      this.testInfo.testAdsIdsUrl[0] = this.testInfo.testSamsungFuseAdTag
    }

  }

  setPlatformId(id:string) {
    this.platform_id = id
  }

  setupPath(platformSettings: PlatformSettings) {
    Log.info('Set Config paths', process.env.NODE_ENV)
    this.buildVersion = this.currentAppVersion = process.env.APP_PROD_VERSION
    let host = window.location.host.split(':')[0]
    let protocol = window.location.protocol
    let rootPath = ''
    let resourcePath = ''
    let apiPath = ''
    const port = window.location.port == '' ? '' : `:${window.location.port}`
    if(protocol == 'file:' && this.platform_id == PLATFORM.SAMSUNG) {
      const url = new URL(window.appHostedPath)
      host = url.host
      protocol = url.protocol
    }
    let localPth = RegExp(
      /(^127\.)|(^10\.)|(^172\.1[6-9]\.)|(^172\.2[0-9]\.)|(^172\.3[0-1]\.)|(^192\.168\.)|(localhost)|local.freeawesometv.com/gm,
      undefined,
    ).test(host)
      ? 'ifood-iptv/'
      : ''
    
    if (this.nodeEnv == 'dev') {
      this.buildVersion = this.currentAppVersion = process.env.APP_DEV_VERSION
      rootPath = process.env.APP_DEV_HOSTED_ROOT_PATH
      resourcePath = process.env.APP_DEV_ASSET_PATH
      apiPath = process.env.APP_DEV_API_ROOT_PATH

      this.appHostedPath = `${protocol}//${host}${port}/${rootPath}`
      this.resouceUrl = `${protocol}//${host}/${resourcePath}`
      this.apiPath = `${protocol}//${host}/${apiPath}`
      platformSettings.path = `./static/`
      if(window.location.protocol == 'file:' && this.platform_id == PLATFORM.SAMSUNG) {
        rootPath = localPth + process.env.APP_PROD_HOSTED_ROOT_SAMSUNG.split('[VERSION]').join(this.buildVersion)
        resourcePath = localPth + process.env.APP_PROD_ASSET_PATH
        apiPath = localPth + process.env.APP_PROD_API_ROOT_PATH_SAMSUNG.split('[VERSION]').join(this.buildVersion)
        platformSettings.path = `${this.appHostedPath}/static/`
      }
      
    } else {
      rootPath = localPth + process.env.APP_PROD_HOSTED_ROOT_PATH.split('[VERSION]').join(this.buildVersion)
      resourcePath = localPth + process.env.APP_PROD_ASSET_PATH
      apiPath = localPth + process.env.APP_PROD_API_ROOT_PATH.split('[VERSION]').join(this.buildVersion)

      if(window.location.protocol == 'file:' && this.platform_id == PLATFORM.SAMSUNG) {
        rootPath = localPth + process.env.APP_PROD_HOSTED_ROOT_SAMSUNG.split('[VERSION]').join(this.buildVersion)
        resourcePath = localPth + process.env.APP_PROD_ASSET_PATH
        apiPath = localPth + process.env.APP_PROD_API_ROOT_PATH_SAMSUNG.split('[VERSION]').join(this.buildVersion)
      }

      this.appHostedPath = `${protocol}//${host}${port}/${rootPath}`
      this.resouceUrl = `${protocol}//${host}/${resourcePath}`
      this.apiPath = `${protocol}//${host}/${apiPath}`
      platformSettings.path = `${this.appHostedPath}/static/`
    }
    window.branch = process.env.APP_SOURC_BRANCH
    //console.log('PATH SETTINGS: ', this.appHostedPath, this.resouceUrl, this.apiPath, platformSettings.path)
  }
}
